import { LANGUAGES } from '@vindr/services/constants/common.constant';
import { ColumnType } from 'antd/es/table';
import { useTranslation } from 'react-i18next';

const StatusColumn = ({
  title = 'Status',
  dataIndex = 'active',
  width = 70,
  key = 'active',
  sorter,
  ellipsis = true,
  render,
  ...props
}: ColumnType<any> = {}) => {
  const { t, i18n } = useTranslation('Vindoc');

  return {
    title: t(title),
    dataIndex,
    key,
    width: i18n.language === LANGUAGES.VI ? Number(width) + 50 : width,
    sorter,
    ellipsis,
    render: render || ((text) => (['true', true].includes(text) ? t('Active') : t('Inactive'))),
    ...props,
  };
};

export default StatusColumn;
